export default __webpack_public_path__ + "static/media/defaultDp.cbb22438.webp";